import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { ModalFactory } from '@rendora/common/features/modals/factory';
import { isMobile } from '@rendora/design/utils/responsive';
import ContactUs from '../ui/ContactUs.vue';

const symbolContactUs = Symbol('contact-us');

/**
 * 联系我们弹窗 composable
 * 提供统一的联系我们弹窗管理功能
 */
export function useContactUs(code: PositionCode, title?: string, description?: string) {
  // 检查是否已存在弹窗实例
  if (ModalFactory.hasModal(symbolContactUs)) {
    const modal = ModalFactory.getInstance(symbolContactUs);
    modal?.update({
      content: <ContactUs code={code} title={title} description={description} />,
    });
    return {
      modal,
    };
  }

  const width = isMobile() ? '45.87vw' : '268px';

  // 创建新的弹窗实例
  const modal = ModalFactory.create(
    {
      width,
      showHeader: false,
      borderRadius: '12px',
      title: '',
      showCloseButton: false,
      content: <ContactUs code={code} title={title} description={description} />,
    },
    symbolContactUs,
  );

  return {
    modal,
  };
}

/**
 * 联系我们弹窗 composable
 * 提供统一的联系我们弹窗管理功能
 */
export function useContactUsByLink(url: string, title?: string, description?: string) {
  // 检查是否已存在弹窗实例
  if (ModalFactory.hasModal(symbolContactUs)) {
    const modal = ModalFactory.getInstance(symbolContactUs);
    modal?.update({
      content: <ContactUs url={url} title={title} description={description} />,
    });
    return {
      modal,
    };
  }

  const width = isMobile() ? '45.87vw' : '268px';

  // 创建新的弹窗实例
  const modal = ModalFactory.create(
    {
      width,
      showHeader: false,
      borderRadius: '12px',
      title: '',
      showCloseButton: false,
      content: <ContactUs url={url} title={title} description={description} />,
    },
    symbolContactUs,
  );

  return {
    modal,
  };
}
